import InstanceVolumeType, {
    InstanceVolumeTypeClassProps,
} from './InstanceVolumeType';

export type InstanceVolumeTypesClassProps = {
    aws: InstanceVolumeTypeClassProps[];
    safespring: InstanceVolumeTypeClassProps[];
    lintasarta: InstanceVolumeTypeClassProps[];
    elastx: InstanceVolumeTypeClassProps[];
    syseleven: InstanceVolumeTypeClassProps[];
};

export interface InstanceVolumeTypesInterface {
    aws: InstanceVolumeType[];
    safespring: InstanceVolumeType[];
    lintasarta: InstanceVolumeType[];
    elastx: InstanceVolumeType[];
    syseleven: InstanceVolumeType[];
}

export default class InstanceVolumeTypes
    implements InstanceVolumeTypesInterface
{
    readonly aws: InstanceVolumeType[];
    readonly safespring: InstanceVolumeType[];
    readonly lintasarta: InstanceVolumeType[];
    readonly elastx: InstanceVolumeType[];
    readonly syseleven: InstanceVolumeType[];

    constructor(props: InstanceVolumeTypesClassProps) {
        this.aws = (props.aws || []).map(
            (vt: InstanceVolumeTypeClassProps) => new InstanceVolumeType(vt)
        );

        this.safespring = (props.safespring || []).map(
            (vt: InstanceVolumeTypeClassProps) => new InstanceVolumeType(vt)
        );

        this.lintasarta = (props.lintasarta || []).map(
            (vt: InstanceVolumeTypeClassProps) => new InstanceVolumeType(vt)
        );

        this.elastx = (props.elastx || []).map(
            (vt: InstanceVolumeTypeClassProps) => new InstanceVolumeType(vt)
        );

        this.syseleven = (props.syseleven || []).map(
            (vt: InstanceVolumeTypeClassProps) => new InstanceVolumeType(vt)
        );
    }
}
